import { Grid2 as Grid } from "@mui/material";
import { UseContractsReturn } from "../../../../api/hooks/useContracts";
import { ContractSummaryCard } from "../components/ContractSummaryCard";

export const ContractsGrid = ({ contracts }: UseContractsReturn) => {
  return (
    <Grid container spacing={6} pl={6} pr={2} pb={6}>
      {contracts?.map((contract) => {
        return (
          <Grid key={contract.id} size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
            <ContractSummaryCard contract={contract} />
          </Grid>
        );
      })}
    </Grid>
  );
};
